"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageStatus = void 0;
var PageStatus;
(function (PageStatus) {
    PageStatus["ACTIVE"] = "ACTIVE";
    PageStatus["INACTIVE"] = "INACTIVE";
})(PageStatus || (exports.PageStatus = PageStatus = {}));
//# sourceMappingURL=page.js.map